import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../utils/constant";

// Async thunk for fetching credit notes
export const fetchCreditNotes = createAsyncThunk(
    "creditNotes/fetchCreditNotes",
    async (company_id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL}/credit-notes/${company_id}`);
            return response.data.data; // Assuming response follows { success: true, data: [...] }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Something went wrong");
        }
    }
);

// Async thunk for adding a new credit note
export const addCreditNote = createAsyncThunk(
    "creditNotes/addCreditNote",
    async (creditNote, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_URL}/credit-notes`, creditNote);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add credit note");
        }
    }
);

// Async thunk for updating a credit note
export const updateCreditNote = createAsyncThunk(
    "creditNotes/updateCreditNote",
    async ({ id, updatedData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${API_URL}/credit-notes/${id}`, updatedData);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update credit note");
        }
    }
);

// Async thunk for deleting a credit note
export const deleteCreditNote = createAsyncThunk(
    "creditNotes/deleteCreditNote",
    async (id, { rejectWithValue }) => {
        try {
            await axios.delete(`${API_URL}/credit-notes/${id}`);
            return id; // Return deleted ID to update state
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to delete credit note");
        }
    }
);

const creditNotesSlice = createSlice({
    name: "creditNotes",
    initialState: {
        creditNotes: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Credit Notes
            .addCase(fetchCreditNotes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCreditNotes.fulfilled, (state, action) => {
                state.loading = false;
                state.creditNotes = action.payload;
            })
            .addCase(fetchCreditNotes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add Credit Note
            .addCase(addCreditNote.fulfilled, (state, action) => {
                state.creditNotes.push(action.payload);
            })

            // Update Credit Note
            .addCase(updateCreditNote.fulfilled, (state, action) => {
                const index = state.creditNotes.findIndex(note => note.id === action.payload.id);
                if (index !== -1) {
                    state.creditNotes[index] = action.payload;
                }
            })

            // Delete Credit Note
            .addCase(deleteCreditNote.fulfilled, (state, action) => {
                state.creditNotes = state.creditNotes.filter(note => note.id !== action.payload);
            });
    }
});

export default creditNotesSlice.reducer;
